import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useBookingContext} from '../../../context/BookingContext';
import {useClinicDetailsContext} from '../../../context/ClinicDetailsContext';
import {PickSiteLanguage} from 'src/components/main/components/PickSiteLanguage';

export function InitialHeader() {
    const {t} = useTranslation();

    const {
        dataState: {careGivers, clinic}
    } = useClinicDetailsContext();
    const {bookingState} = useBookingContext();

    const navigate = useNavigate();

    if (clinic?.externalBookingUrl) {
        window.location.href = clinic.externalBookingUrl;
    }

    const caregiverName = careGivers.find((caregiver) => caregiver.id === clinic?.principalCareGiver)?.label;

    return (
        <header className='header-nav'>
            <div className='header-nav__flex'>
                {clinic?.logoUrl && (
                    <img
                        className='header-nav__clinic-logo'
                        src={clinic?.logoUrl}
                        height='32'
                        alt={`${clinic?.name} logo`}
                    />
                )}
                {!clinic?.logoUrl && <h3 className='region-name'>{caregiverName}</h3>}
                {clinic?.externalBookingUrl && <div>{t('clinic_details.redirect_msg')}</div>}

                <PickSiteLanguage />
            </div>

            {!clinic?.externalBookingUrl && (
                <div className='header-nav__links'>
                    {clinic && bookingState.bookingType !== 'healthDeclaration' && (
                        <button
                            onClick={() => {
                                navigate(`/hantera`, {
                                    state: {
                                        clinicId: clinic.id
                                    }
                                });
                            }}
                            className='primary'
                        >
                            {t('clinic_details.handle_booking')}
                        </button>
                    )}
                </div>
            )}
        </header>
    );
}
